// Google Analytics 4 Integration
export const initGA = (measurementId) => {
  if (!measurementId) return;

  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script1);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  
  gtag('js', new Date());
  gtag('config', measurementId, { send_page_view: true });
};

export const trackPageView = (path) => {
  if (window.gtag) window.gtag('event', 'page_view', { page_path: path });
};

export const trackEvent = (eventName, eventParams = {}) => {
  if (window.gtag) window.gtag('event', eventName, eventParams);
};

export const trackPhoneClick = (phoneNumber, location) => {
  trackEvent('phone_click', { phone_number: phoneNumber, location, event_category: 'engagement' });
};

export const trackBookingStarted = () => {
  trackEvent('booking_started', { event_category: 'conversion' });
};

export const trackBookingCompleted = (vehicleType, date) => {
  trackEvent('booking_completed', { vehicle_type: vehicleType, booking_date: date, event_category: 'conversion', value: 1 });
};

export const trackSearch = (searchQuery) => {
  trackEvent('search', { search_term: searchQuery, event_category: 'engagement' });
};

export const initScrollTracking = () => {
  let depths = [25, 50, 75, 100], tracked = new Set();
  const handle = () => {
    const pct = Math.round((window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100);
    depths.forEach(d => { if (pct >= d && !tracked.has(d)) { tracked.add(d); trackEvent('scroll_depth', { scroll_depth: d }); }});
  };
  window.addEventListener('scroll', handle, { passive: true });
  return () => window.removeEventListener('scroll', handle);
};
